import BreadScrumbs from "../breadscrumb";
import nft from "../../assets/images/nft.png"
export default function InventoryNFTDetail() {
    //console.log('nft')
    function displaySellBox(){
        //console.log('box')
        window.dispatchEvent( new CustomEvent("displaySellBox",
      {
        detail:true
      }) )
    }
   
    function displayTransferBox(){
        //console.log('box')
        window.dispatchEvent( new CustomEvent("displayTransferBox",
      {
        detail:true
      }) )
    }
    return (
        <>
            <div>
                <BreadScrumbs name={'NFT detail'} />
            </div>
            <div className=" w-full bg-[#040B11] px-[6.4rem] py-[10rem]  xl:px-[25.5rem] flex flex-col sm:flex-row items-center">
                <div className="sm:min-w-[45rem] xl:w-[69rem]">
                    <img draggable={true} onDrag={()=>{console.log('on draging')}} src={nft} alt="nft  detail" />
                </div>
                <div className="min-w-[rem] ml-0 mt-[2.4rem] sm:mt-0 sm:ml-[10rem]">
                    <h3 className="text-white mb-[2.4rem]">Lorem ipsum #123,456</h3>
                    <p className="mb-[2rem] text-[#C2C3C5] font-poppin text-[2rem] leading-[3rem]">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Egestas dictum elit luctus tristique odio vitae diam ac. Dignissim tempor ultrices interdum nulla porttitor vitae. In.</p>
                    <div className="w-full flex justify-start gap-[1.6rem]  mb-[2.4rem]">
                        <div className="p-[2rem]  bg-third ">
                            <p className="text-[1.6rem] text-[#C2C3C5]">Tire</p>
                            <p className="text-white text-[2.4rem]">01</p>
                        </div>
                        <div className="p-[2rem] w-[19.6rem] bg-third">
                            <p className="text-[1.6rem] text-[#C2C3C5]">National</p>
                            <p className="text-white text-[2.4rem]">Lorem ipsum</p>
                        </div>
                    </div>
                    <div className="w-full flex justify-start gap-[0.8rem]">
                        <button onClick={displaySellBox} type={'button'} className="max-w-[29rem] w-full mr-[4rem]  py-[1.6rem] bg-primary rounded-full font-bakbak text-[1.6rem] active:bg-opacity-50 transition-all duration-300 text-black text-center">
                        SELL
                        </button>
                        <button onClick={displayTransferBox} type={'button'} className="max-w-[29rem] w-full py-[1.6rem] bg-primary rounded-full font-bakbak text-[1.6rem] active:bg-opacity-50 transition-all duration-300 text-black text-center">
                        TRANSFER
                        </button>
                    </div>
                </div>
                
            </div>
        </>
    )
}